export default __webpack_public_path__ + "static/media/customer.e4473888.png";